<template>
    <div>
        <div class="first-rect" :class="[readOnly==true?'onlyread':'']" tabindex="1" >
            <div :class="[readOnly==true?'onlyreadcursor':'']" @click="handleClickTranditional">
                <img src="@/assets/images/bookIcons/complex1.png" class="icon">
                <img src="@/assets/images/bookIcons/complex2.png" class="point-icon">
                <div class="word">{{ this.traditional ? '简体' : '繁体' }}</div>
            </div>
        </div>
        <div class="other-rect" :class="[readOnly==true?'onlyread':'']" tabindex="2" >
            <div :class="[readOnly==true?'onlyreadcursor':'']" @click="openOcr=true">
                <img src="@/assets/images/bookIcons/OCR1.png" class="icon">
                <img src="@/assets/images/bookIcons/OCR2.png" class="point-icon">
                <div class="word">OCR</div>
            </div>
        </div>
        <div class="other-rect" :class="[readOnly==true?'onlyread':'']" tabindex="3" >
            <div :class="[readOnly==true?'onlyreadcursor':'']" @click="openTranslate=true">
                <div class="translate-toolbar-icon">译</div>
                <div class="word auto-translate-word">自动翻译</div>
            </div>
        </div>
        <div class="other-rect" :class="[readOnly==true?'onlyread':'']" tabindex="4" >
            <div :class="[readOnly==true?'onlyreadcursor':'']" @click="handleClickSearch">
            <img src="@/assets/images/bookIcons/search1.png" class="icon">
            <img src="@/assets/images/bookIcons/search2.png" class="point-icon">
            <div class="word">查找</div>
            </div>
        </div>
        <div class="other-rect" :class="[noteRead==true?'onlyread':'']" tabindex="5">
            <div :class="[noteRead==true?'onlyreadcursor':'']" @click="handleOpenNote">
                <img src="@/assets/images/bookIcons/note1.png" class="icon">
                <img src="@/assets/images/bookIcons/note2.png" class="point-icon">
                <div class="word">笔记</div>
            </div>
        </div>
        <div class="other-rect" :class="[readOnly==true?'onlyread':'']" tabindex="6" >
            <div :class="[readOnly==true?'onlyreadcursor':'']" @click="openComment=true">
                <img src="@/assets/images/bookIcons/commit1.png" class="icon">
                <img src="@/assets/images/bookIcons/commit2.png" class="point-icon">
                <div class="word">评论</div>
            </div>
        </div>
        <div class="other-rect" :class="[readOnly==true?'onlyread':'']">
            <div :class="[readOnly==true?'onlyreadcursor':'']" @click="isShow = !isShow">
                <img src="@/assets/images/bookIcons/limit1.png" class="icon">
                <div class="word" v-if="isShow">收起</div>
                <div class="word" v-else>展开</div>
            </div>
        </div>
        <div class="other-rect" :class="[readOnly==true?'onlyread':'']" v-show="isShow" tabindex="7">
            <div :class="[readOnly==true?'onlyreadcursor':'']" @click="handleClickBookmark">
                <img src="@/assets/images/bookIcons/bookmark1.png" class="icon">
                <img src="@/assets/images/bookIcons/bookmark2.png" class="point-icon">
                <div class="word">书签</div>
            </div>
        </div>
        <div class="other-rect" :class="[readOnly==true?'onlyread':'']" v-show="isShow" tabindex="8" >
            <div :class="[readOnly==true?'onlyreadcursor':'']" @click="showKeyword()">
                <img src="@/assets/images/bookIcons/keyword1.png" class="icon">
                <img src="@/assets/images/bookIcons/keyword2.png" class="point-icon">
                <div class="word">关键词</div>
            </div>
        </div>
        <div class="special-rect" :class="[readOnly==true?'onlyread':'']" v-show="isShow" tabindex="9"  v-if="isCollected === true">
            <div :class="[readOnly==true?'onlyreadcursor':'']" @click="deleCollections">
                <img src="@/assets/images/bookIcons/collect2.png" class="point-icon">
                <img src="@/assets/images/bookIcons/collect2.png" class="icon">
                <div class="word">取消收藏</div>
            </div>
        </div>
        <div class="other-rect" :class="[readOnly==true?'onlyread':'']" v-show="isShow" tabindex="9"  v-else>
            <div :class="[readOnly==true?'onlyreadcursor':'']" @click="handleopenCollect">
                <img src="@/assets/images/bookIcons/collect1.png" class="icon">
                <img src="@/assets/images/bookIcons/collect2.png" class="point-icon">
                <div class="word">收藏</div>
            </div>
        </div>
        <div class="other-rect" v-show="isShow" tabindex="10" @click="openShareDialog">
            <img src="@/assets/images/bookIcons/share1.png" class="icon">
            <img src="@/assets/images/bookIcons/share2.png" class="point-icon">
            <div class="word">分享</div>
        </div>
        <my-dialog
          :title="'提示'"
          :icon="require('@/assets/images/userPage/user.png')"
          ref="messageDialog"
          class="message-dialog"
          @confirm="clearHistory"
        >
          确认取消该收藏？
        </my-dialog>
        <retrieve-dialog-ocr v-if="openOcr" :openOcr="openOcr" :bookId='bookId' :currentPage='currentPage' @closeOcr="openOcr = false"></retrieve-dialog-ocr>
        <retrieve-dialog-translate v-if="openTranslate" :openTranslate="openTranslate" :bookId='bookId' :currentPage='currentPage' @closeTranslate="openTranslate = false"></retrieve-dialog-translate>
        <RetrieveDialogNote v-if="openNote" :openNote="openNote" :bookId='bookId' :currentPage='currentPage' @closeNote="closeNote"></RetrieveDialogNote>
        <RetrieveDialogComment v-if="openComment" :openComment="openComment" :bookId='bookId' :currentPage='currentPage' :noteRead="noteRead" @closeComment="closeComment"></RetrieveDialogComment>
        <RetrieveDialogKeyword v-if="openKeyword" :openKeyword="openKeyword" :bookId='bookId' :currentPage='currentPage' @closeKeyword="closeKeyword" @changeCurrentPage="changeCurrentPage"></RetrieveDialogKeyword>
        <RetrieveDialogCollect v-if="openCollect" :openCollect="openCollect" :bookId='bookId' @collectSuccess="collectSuccess" @closeCollect="closeCollect"></RetrieveDialogCollect>
        <el-dialog :visible.sync="openShare" width="30%" class="share-dialog" center>
            <img class="share-icon" src="@/assets/images/bookIcons/shareicon.png" alt="">
            <span>已成功复制分享链接</span>
            <div class="second">({{ second }}s)</div>
        </el-dialog>
    </div>
</template>

<script>
import RetrieveDialogComment from './RetrieveDialogComment.vue'
import RetrieveDialogCollect from './RetrieveDialogCollect.vue'
import RetrieveDialogKeyword from './RetrieveDialogKeyword.vue'
import RetrieveDialogNote from './RetrieveDialogNote.vue'
import RetrieveDialogOcr from './RetrieveDialogOcr.vue'
import RetrieveDialogTranslate from './RetrieveDialogTranslate.vue'
import MyDialog from './MyDialog.vue'
import { Message } from 'element-ui'

export default {
  name: 'RetrieveRightMenu',
  components: {RetrieveDialogComment, RetrieveDialogCollect, RetrieveDialogKeyword, RetrieveDialogNote, RetrieveDialogOcr, RetrieveDialogTranslate, MyDialog},
  props: {
    bookId: {
      type: String,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    // defaultPermission: {
    //   type: Number,
    //   required: true
    // },
    isCollected: {
      type: Boolean,
      required: true
    },
    traditional: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isShow: true,
      openOcr: false,
      openCollect: false,
      openComment: false,
      openTranslate: false,
      openShare: false,
      openKeyword: false,
      openKeywordAll: false,
      openNote: false,
      second: 3,
      url: '',
      readOnly: false,
      noteRead: false,
      defaultPermission: 40
    }
  },
  created () {
    // 获取当前页面的网址
    this.url = window.location.href
  },
  mounted () {
    this.$bus.$on('collectSuccess', data => {
      this.isCollected = true
    })
    // this.$bus.$on('collectSuccess', data => {
    //   this.isCollected = true
    // })
    if (localStorage.getItem('isLogined') === 'true') {
      this.defaultPermission = Number(localStorage.getItem('defaultPermission'))
      console.log('222', this.defaultPermission)
    }
    console.log('right', this.defaultPermission)
    // console.log('defaultPermission', typeOf(this.defaultPermission))
    if (this.defaultPermission === 40) {
      this.noteRead = true
    }
  },
  methods: {
    handleOpenNote () {
      this.openNote = true
    },
    handleopenCollect () {
      if (String(localStorage.getItem('isLogined')) === 'true') {
        this.openCollect = true
      } else {
        Message({
          type: 'error',
          message: '用户需要登录才能完成操作!'
        })
      }
    },
    closeNote () {
      this.openNote = false
    },
    closeComment () {
      this.openComment = false
    },
    closeCollect () {
      this.openCollect = false
    },
    closeKeyword () {
      this.openKeyword = false
    },
    closeKeywordAll () {
      this.openKeywordAll = false
    },
    changeCurrentPage (page) {
      this.currentPage = page
      console.log('pagerrr', this.currentPage)
      this.$emit('changeCurrentPage', this.currentPage)
    },
    showKeyword () {
      this.openKeyword = true
      this.openKeywordAll = true
    },
    openShareDialog () {
      const clipboard = navigator.clipboard || {
        writeText: (text) => {
          const input = document.createElement('input')
          input.value = text
          document.body.appendChild(input)
          input.select()
          document.execCommand('copy')
          document.body.removeChild(input)
        }
      }
      clipboard.writeText(window.location.href)
      let _this = this
      this.openShare = true
      this.second = 3
      _this.timer = setInterval(function () { // 定时器开始
        _this.second--
        if (_this.second === 0) {
          clearInterval(_this.timer)// 满足条件时 停止计时
          // _this.sendMsg();
          _this.openShare = false
        }
      }, 1000)
    },

    // openShareDialog () {
    //   this.openShare = true
    //   this.second = 3
    //   let interval = window.setInterval(function () {
    //     this.sencond = this.sencond - 1
    //     if (this.sencond === 0) {
    //       window.clearInterval(interval)
    //       window.close()
    //       this.openShare = false
    //     //   this.sendMsg()// 倒计时结束时运行的业务逻辑，这里的是关闭当前页面
    //     }
    //   }, 1000)
    // },
    // 已收藏，再次点击可以取消收藏
    deleCollections () {
      this.$refs.messageDialog.open(() => {
        let userId = localStorage.getItem('userId')
        let url = 'retrieve/storeBook/deleteBookInStore?userId=' + userId + '&bookId=' + this.bookId
        this.$http.delete(url).then(res => {
          Message({
            type: 'success',
            message: '取消收藏成功!'
          })
          this.isCollected = false
        })
          .catch(() => {
          // console.log('失败')
            Message({
              type: 'error',
              message: '取消收藏失败!'
            })
          })
      })
    },
    clearHistory () {
      this.$refs.messageDialog.close()
    },
    handleClickTranditional () {
      this.$emit('update:traditional', !this.traditional)
    },
    handleClickSearch () {
      this.$emit('search')
    },
    handleClickBookmark () {
      var url = window.location
      var title = document.title
      var ua = navigator.userAgent.toLowerCase()
      if (ua.indexOf('360se') > -1) {
        Message.warning('由于360浏览器功能限制, 请按 Ctrl+D 手动收藏！')
      } else if (ua.indexOf('msie 8') > -1) {
        window.external.AddToFavoritesBar(url, title) // IE8
      } else if (document.all) { // IE类浏览器
        try {
          window.external.addFavorite(url, title)
        } catch (e) {
          Message.warning('您的浏览器不支持,请按 Ctrl+D 手动收藏!')
        }
      } else if (window.sidebar && window.sidebar.addPanel) { // firfox等浏览器；
        window.sidebar.addPanel(title, url, '')
      } else {
        Message.warning('您的浏览器不支持,请按 Ctrl+D 手动收藏!')
      }
    }
  },
  watch: {
    // currentPage () {
    //   if (localStorage.getItem('isLogined') === true) {
    //     this.defaultPermission = Number(localStorage.getItem('defaultPermission'))
    //   }
    //   if (this.defaultPermission === 40) {
    //     this.noteRead = true
    //   }
    // }
  }
}
</script>

<style scoped>
#mask{
  width: 100%;
  opacity: 0.3;
  background-color: black;
  /* bottom: 0; */
  /* left: 0; */
  position: fixed;
  z-index: 2998;

}
.onlyread{
cursor: not-allowed !important;
opacity: 0.3;
background-color: black;
}
.onlyreadcursor{
pointer-events: none;
}
.first-rect {
    height: 60px;
    width: 60px;
    background-color: #FFFFFF;
    cursor: pointer;
}

.other-rect {
    margin-top: 10px;
    height: 60px;
    width: 60px;
    background-color: #FFFFFF;
    cursor: pointer;
}
.share-dialog >>> .el-dialog__headerbtn {
    top: 5px !important;
    right: 4px;
    background: url('../assets/images/bookIcons/close.png') left no-repeat;
    background-size: cover;
    font-family:"Avenir", Helvetica, Arial, sans-serif;
    width:20px;
    height: 20px;
}
div:focus {
    background-color: #9E5C1D;
}

div:focus .word {
    color: #FFFFFF;
}

div:focus .icon {
    display: none;
}

div:focus .point-icon {
    display: block;
}

.icon {
    height: 24px;
    width: 24px;
    display: block;
    margin: 0 auto;
}

.point-icon {
    height: 24px;
    width: 24px;
    display: none;
    margin: 0 auto;
}
.translate-toolbar-icon {
    height: 24px;
    width: 24px;
    line-height: 22px;
    box-sizing: border-box;
    border: 1px solid #9E5C1D;
    color: #9E5C1D;
    font-size: 14px;
    font-weight: bold;
    display: block;
    margin: 0 auto;
}
div:focus .translate-toolbar-icon {
    border-color: #FFFFFF;
    color: #FFFFFF;
}
.special-rect {
    margin-top: 10px;
    height: 60px;
    width: 60px;
    background-color: #9E5C1D;
    cursor: pointer;
}
.special-rect .word {
    color: #FFFFFF;
}
/* .special-rect:focus .word {
    color: black;
}
.special-rect:focus {
    background-color: #FFFFFF;
} */
.word {
    font-size: 12px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #634C37;
    margin-top: 11px;
    /* margin-bottom: 9px; */
}
.auto-translate-word {
    margin-top: 7px;
    line-height: 14px;
}

/* 分享弹窗 */
.share-dialog>>>.el-dialog {
    height: 198px;
    width: 347px !important;
    margin-top: 35vh !important;
}

.share-dialog>>>.el-dialog__header {
    padding: 0;
}

.share-icon {
    display: block;
    margin: 0 auto;
    height: 49px;
    width: 49px;
    margin-bottom: 30px;
}

.share-dialog>>>.el-dialog__body {
    text-align: center;
    padding-top: 43px;
}

.second{
font-size: 12px;
font-weight: 400;
color: #9E5C1D;
line-height: 36px;
}

.message-dialog >>> .el-dialog {
  width: 380px;
  height: 265px;
}

.message-dialog >>> .el-dialog__body {
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #634c37;
}
</style>



// WEBPACK FOOTER //
// src/components/RetrieveRightMenu.vue